var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpRightBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 24,
    viewBox: "0 0 14 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Arrow_2",
    d: "M1.29289 17.2929C0.902369 17.6834 0.902369 18.3166 1.29289 18.7071C1.68342 19.0976 2.31658 19.0976 2.70711 18.7071L1.29289 17.2929ZM14 7C14 6.44771 13.5523 6 13 6L4 6C3.44772 6 3 6.44771 3 7C3 7.55228 3.44772 8 4 8L12 8L12 16C12 16.5523 12.4477 17 13 17C13.5523 17 14 16.5523 14 16L14 7ZM2.70711 18.7071L13.7071 7.70711L12.2929 6.29289L1.29289 17.2929L2.70711 18.7071Z",
    fill: "#090808"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpRightBlack);
export default __webpack_public_path__ + "static/media/Arrow-up-right-black.aeaedaa985a5dd0f34d478016e243fce.svg";
export { ForwardRef as ReactComponent };